import React from "react";
import TabHub from "@/components/TabHub";
import TribalStructure from "@/pages/TribalStructure";
import Structure from "@/pages/Structure";

export default function InstitutionHub() {
  return (
    <TabHub
      testid="institution-hub"
      eyebrow="The Institution"
      title="Tribal structure & institutional philosophy."
      subtitle="Explore the governance of the Trust and the sovereign-minded philosophy that makes its architecture endure."
      tabs={[
        { key: "structure", label: "Tribal Structure", component: <TribalStructure embedded /> },
        { key: "philosophy", label: "Institutional Philosophy", component: <Structure embedded /> },
      ]}
    />
  );
}
